import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  logo: {
    display: 'block',
    width: 'auto',
    height: 70,
    maxWidth: 180,
    objectFit: 'contain',
  },
});
const LogoFull = () => {
  const classes = useStyles();

  return (
    <img
      className={classes.logo}
      src="/zest-logo2.png"
      alt="Zest"
    />
  );
};

export default LogoFull;
